// extracted by mini-css-extract-plugin
module.exports = {"card":"UserTeamCard_card__UQKgK","delete":"UserTeamCard_delete__1MqLm"};